import { render, staticRenderFns } from "./UpdateNews.vue?vue&type=template&id=160782e4&"
import script from "./UpdateNews.vue?vue&type=script&lang=js&"
export * from "./UpdateNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports